// extracted by mini-css-extract-plugin
module.exports = {"footer":"ModalFooter-styles_footer__PCMO2","error":"ModalFooter-styles_error__1vgkX","buttons":"ModalFooter-styles_buttons__2ot5b"};